import React from 'react';
import { getEnvironmentName, PRODUCTION } from 'utils/env';

export default getEnvironmentName() !== PRODUCTION
  ? React.lazy(() => import('./swr-devtools'))
  : React.Fragment;
